module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 261.8 226.7'%3E%3Cpath fill='%234DBA87' d='M161.15-.01l-30.267 52.4-30.266-52.4H-.05l130.933 226.665L261.817-.01H161.15z'/%3E%3Cpath fill='%23435466' d='M161.15-.01l-30.267 52.4-30.266-52.4H52.35l78.533 136 78.534-136H161.15z'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./assets/img/tools/vue.svg
// module id = 71
// module chunks = 0